import React from 'react'
import Link from 'next/link'
import { Section } from '../section/section.component'
import { motion } from 'framer-motion'
import { sanitySrcUrl } from '../../lib/libFunctions'
import { base } from '../../styles/base/_allBase.styles'
const { H5 } = base
import {
  SectionContainer,
  Card,
  CardImage,
  CardOverlay,
  CardTitle,
} from './featured-topics-section.styles.js'
import { analyticsModuleAttributes } from '../../lib/analytics-content.mjs'

const gridAreas = ['card1', 'card2', 'card3', 'card4']

const FeaturedTopicsSection = React.memo(({ topics = [], module }) => {
  return (
    <Section
      cursorsize="small"
      size={'auto'}
      {...analyticsModuleAttributes(module || { _key: 'featured-topics' }, 'featured_topics')}
    >
      <SectionContainer as={motion.div}>
        <h2>Explore Selong Belanak</h2>
        {topics.slice(0, 4).map((topic, i) => (
          <Link key={topic._key || topic.slug.current} href={`/${topic.slug.current.replace(/^\//, '')}`} passHref legacyBehavior>
            <Card
              as="a"
              $area={gridAreas[i]}
              data-analytics-cta-id={`featured-topic-${topic._key || topic.slug.current}`}
              data-analytics-cta-type="internal_navigation"
              data-analytics-cta-label={topic.title}
              data-analytics-placement-id="featured-topics"
            >
              <CardImage
                src={sanitySrcUrl(topic.photo)}
                alt={topic.photo?.alt || topic.title}
                sizes="(max-width:767px) 100vw, 25vw"
                fill
              />
              <CardOverlay />
              <CardTitle>
                <h3>{topic.title}</h3>
              </CardTitle>
            </Card>
          </Link>
        ))}
      </SectionContainer>
    </Section>
  )
})

FeaturedTopicsSection.displayName = 'FeaturedTopicsSection'
export { FeaturedTopicsSection }
